export default __webpack_public_path__ + "static/new-insight-dark-mode-4df2cbd79f1067e9747a95dd83e7f0b7.png";